<template>
  <div class="directory-landing-page">
    <TopBarInfo />
    <HeroBlock v-if="data.hero" :model="data.hero" />
    <HeroOverlayCard
      v-if="data.heroOverlay.length > 0"
      :model="pageStore.getLinkedItem<HeroOverlayCardModel>(data.heroOverlay[0])"
    />
    <SmartLinkItemComponent
      custom-tag="div"
      class="container"
      v-if="page"
      :id="page.system.id"
      :component="!page.system.workflow"
    >
      <SmartLinkStandaloneElement
        custom-tag="div"
        class="text"
        :codename="contentTypes.directory_landing_page.elements.content.codename"
      >
        <RichText :value="data.content" />
      </SmartLinkStandaloneElement>
    </SmartLinkItemComponent>
  </div>
</template>

<script lang="ts" setup>
import { contentTypes, type HeroModel, type HeroOverlayCardModel } from '~/models'
import type { DirectoryLandingPageModel } from '~/models'
import type { IContentItem } from '@kontent-ai/delivery-sdk'
import TopBarInfo from '~/components/header/TopBarInfo.vue'

const pageStore = usePageStore()
const siteStore = useSiteStore()

const page = pageStore.page as DirectoryLandingPageModel

const data = {
  homepages: pageStore.getListAs<IContentItem>(page.elements.homepages.value),
  content: page.elements.content.value,
  title: page.elements.title.value,
  heroOverlay: page?.elements.heroOverlay.value,
  hero: pageStore.getLinkedItem<HeroModel>(page?.elements.hero.value[0]),
  topBarInfo: page.elements.topBarInfo.value
}

</script>
